import { Project } from 'projects/app-misc/src/app/modules/project-misc/data/project/project';
import { AbstractModel, JsonObject, JsonProperty, DateConverter } from 'projects/core/src/public-api';
import { ProjectStatus } from 'projects/app-misc/src/app/modules/project-misc/data/project/statuses/project-status';
import { ShortProject } from 'projects/app-misc/src/app/modules/project-misc/data/project/short-project';
import { Tray } from './tray';

@JsonObject('model.CartStatus')
export class CartStatus extends AbstractModel {
  @JsonProperty(String, 'color')
  color: string;

  @JsonProperty(String, 'title')
  title: string;
}
